import create from "zustand";
export const hamburgerStore = create((set) => ({
  isOpened: false,
  open: () => set((state) => ({ isOpened: true })),
  close: () => set((state) => ({ isOpened: false })),
  toggle: () => set((state) => ({ isOpened: !state })),
}));
